<template>
<div>
    
    <v-dialog
    v-model="activeModal" 
    max-width="300px"
    class="modal-qrCode"
    content-class="custom-modal-qrCode">
    <v-card class="custom-modal-card">
      <v-toolbar flat height="40px" class="modal-qrCode-toolbar">
          <v-spacer></v-spacer>
          <v-icon @click="closeModal" class="modal-qrCode-close">close</v-icon>
      </v-toolbar>

        <v-card-title class="modal-qrCode-titulo">
          {{ $t('links.escaneieQrCode') }}
        </v-card-title>

        <v-card-text class="modal-qrCode-form">
          <v-row>
            <qrcode-vue :value="url" :size="150" render-as="svg" />
          </v-row>
        </v-card-text>
    </v-card>
</v-dialog>

</div>  
</template>


<script>
    import variables from '@/assets/styles/helpers/_variables.scss'
    import QrcodeVue from 'qrcode.vue'
    import Events from '@/core/service/events'
    export default {
        name: 'modalQrCodeVue',
        components: {
            QrcodeVue
        },
        data() {
            return {
                url: '', 
                activeModal: false,

            }
        },
        computed: {
            variables: () => variables,
        },
        methods: {
            openModal () {
                this.activeModal = true
            },
            closeModal () {
                this.activeModal = false
            },
        },
        mounted () {
            Events.$on('links::openModalQrCode', (url) => {
            this.openModal()
            this.url = url
        })
  },

    }
         
</script>

<style lang="scss" scoped>
@import '@/assets/styles/helpers/_variables.scss';

.v-card.v-sheet.theme--light{
  .v-toolbar__content {
    background: #1D1D29 !important;
  }

}
  .row {
    margin-left: 53px;
  }
.custom-modal-card {
    background-color: linear-gradient(to bottom, #e0f7e0, #006400);
    border-radius: 12px;
    width: 300px;
    height: 300px;
    box-shadow: none;
  }
  
  .modal-qrCode-toolbar {
    background-color: $colorSuccess;
  }

  .modal-qrCode-close {
    color: #333;
    cursor: pointer;
  }

  .modal-qrCode-titulo {
    font-size: 1.5rem;
    color: #333;
    padding: 16px;
    margin-left: 17px ;
    color: #FFF;
  }

  .modal-qrCode-form {
    padding: 20px;
  }

</style>